import './App.css';
import { Route, Routes } from 'react-router-dom';
import Home from './components/views/Home';
import InformationView from './components/views/InformationView';
import Footer from './components/layout/Footer';
import Header from './components/layout/Header';
import Navbar from './components/layout/Navbar';
import FormView from './components/views/FormView';
import News from './components/views/News';
import UpdateView from './components/views/UpdateView';
import LoginView from './components/views/LoginView';
import { Navigate } from 'react-router-dom';
import { useState } from 'react';
import NotificationView from './components/views/NotificationView';
import FunctionView from './components/views/FunctionView';
import Logout from './components/logout/logout';

function App() {

  const [isLoggedIn, SetIsLoggedIn] = useState(true);

  
  return (
    <>
      <Header />

      <div className='main'>
        <Navbar />
        <Routes>
        
        <Route path='/Function' element={<FunctionView />}/>
          <Route path='/' element={<InformationView />}/>
          <Route path='/news/:id' element={<News />}/>
          <Route path='/create-form' element={<FormView />}/>
          <Route path='/update/:id' element={<UpdateView />}/>
          <Route path='/login' element={<LoginView />}/>
          <Route path='/Notification' element={<NotificationView />}/>
          <Route path='/logout' element={<Logout />}/>
        </Routes>
      </div>
    
      <Footer />
    </>
  );
}

export default App;
